import EnbNave01 from './EnbNave01/EnbNave01'
import EnbNave02 from './EnbNave02/EnbNave02'

export default {
  EnbNave01,
  EnbNave02
}
